enum TASK_ITEM_STATUS {
  COMPLETED = 'Completed',
  PENDING_NORMAL = 'Pending_Normal',
  PENDING_URGENT = 'Pending_Urgent',
  BLOCKED = 'Blocked'
}

export default TASK_ITEM_STATUS;
